import { BaseQueryParams, DocSubmission, DocSubmissionDto, DocType, IResponsePaginate, WithMetadata } from '@/types';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DocSubmissionService {
  BASEURL = `${environment.api.paramsUrl}/doc-soumission`;
  httpClient = inject(HttpClient);

  getAll(params?: BaseQueryParams): Observable<IResponsePaginate<DocSubmission>> {
    return this.httpClient.get<IResponsePaginate<DocSubmission>>(`${this.BASEURL}`, { params: params as HttpParams });
  }

  getOne(id: number): Observable<WithMetadata<DocSubmission>> {
    return this.httpClient.get<WithMetadata<DocSubmission>>(`${this.BASEURL}/${id}`);
  }

  create(docSubmission: DocSubmissionDto): Observable<WithMetadata<DocSubmission>> {
    return this.httpClient.post<WithMetadata<DocSubmission>>(`${this.BASEURL}`, docSubmission);
  }

  update(id: number, docSubmission: DocSubmissionDto): Observable<WithMetadata<DocSubmission>> {
    return this.httpClient.put<WithMetadata<DocSubmission>>(`${this.BASEURL}/${id}`, docSubmission);
  }

  delete(id: number): Observable<WithMetadata<DocSubmission>> {
    return this.httpClient.delete<WithMetadata<DocSubmission>>(`${this.BASEURL}/${id}`);
  }

  getAllFolderTypes() {
    return this.httpClient.get<DocType[]>(`${environment.api.paramsUrl}/type-dossier`);
  }
}
